/**
 * 智能翻译接口api
 */
import { ajaxPostJson } from './ajax';


// 语言自动检测
export const textLangRecognition = (params) => {
  return ajaxPostJson(`/common/textLangRecognition`, params, 'BaseApi');
}

// 文本翻译
export const getSentTranslation = (params) => {
  return ajaxPostJson(`/sent/getSentTranslation`, params, 'BaseApi');
}